import { useEffect, useState } from 'react';

import { useGlobal } from '../../hooks/useGlobal';
import api from '../../services/api';
import { formatToLocaleCurrency } from '../../util/formats';
import { errorMessage } from '../../util/toast';

import { Card } from '../../components/Table';

import IconPaga from '../../assets/iconCobrancaPaga.svg';
import IconVencida from '../../assets/iconCobrancaVencida.svg';
import IconPrevista from '../../assets/iconCobrancaPrevista.svg';
import './styles.css';

function Home() {
  const { setHeaderText, token } = useGlobal();
  const [cobrancasPagas, setCobrancasPagas] = useState([]);
  const [cobrancasPagasResumo, setCobrancasPagasResumo] = useState({});
  const [cobrancasPrevistas, setCobrancasPrevistas] = useState([]);
  const [cobrancasPrevistasResumo, setCobrancasPrevistasResumo] = useState({});
  const [cobrancasVencidas, setCobrancasVencidas] = useState([]);
  const [cobrancasVencidasResumo, setCobrancasVencidasResumo] = useState({});
  const [listaClientes, setListaClientes] = useState({});
  const {goTo} = useGlobal();

  useEffect(() => {
    setHeaderText('Resumo das cobranças');
    goTo(0);
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    try {
      /* ----------------  Pagas  ---------------- */
      const cardTotalPagas = async () => {
        return await api.get('/cobrancas/card_total_paga', config);
      };
      cardTotalPagas().then(({ data: resumoCobrancasPagas }) => {
        // @ts-ignore
        setCobrancasPagasResumo({ ...resumoCobrancasPagas });
      });

      const cobrancasPagasReq = async () => {
        return await api.get('/cobrancas/pagas_cobrancas', config);
      };
      cobrancasPagasReq().then(({ data: listaCobrancasPagas }) => {
        setCobrancasPagas([...listaCobrancasPagas]);
      });

      /* ----------------  Previstas  ---------------- */
      const cardTotalPrevistas = async () => {
        return await api.get('/cobrancas/card_total_prevista', config);
      };
      cardTotalPrevistas().then(({ data: resumoCobrancasPrevistas }) => {
        setCobrancasPrevistasResumo({ ...resumoCobrancasPrevistas });
      });

      const cobrancasPrevistasReq = async () => {
        return await api.get('/cobrancas/pendente_cobrancas', config);
      };
      cobrancasPrevistasReq().then(({ data: listaCobrancasPrevistas }) => {
        setCobrancasPrevistas([...listaCobrancasPrevistas]);
      });

      /* ----------------  Vencidas  ---------------- */
      const cardTotalVencidas = async () => {
        return await api.get('/cobrancas/card_total_vencidas', config);
      };
      cardTotalVencidas().then(({ data: resumoCobrancasVencidas }) => {
        setCobrancasVencidasResumo({ ...resumoCobrancasVencidas });
      });

      const cobrancasVencidasReq = async () => {
        return await api.get('/cobrancas/vencidas_cobrancas', config);
      };
      cobrancasVencidasReq().then(({ data: listaCobrancasVencidas }) => {
        setCobrancasVencidas([...listaCobrancasVencidas]);
      });

      /* ----------------  Clientes  ---------------- */
      const verTodosClientes = async () => {
        return await api.get('/clientes/ver_todos_clientes', config);
      };
      verTodosClientes().then(({ data: listaDadosClientes }) => {
        setListaClientes({ ...listaDadosClientes });
      });
    } catch (e) {
      console.error('erro>', e);
      errorMessage(e.response.data);
    };
  }, []);

  return (
    <div className='container-home'>
      <div className='resumo-container'>
        <div className='cobrancapaga'>
          <div className='container-icones'>
            <img src={IconPaga} alt='icone' />
          </div>

          <div className='cobranca-infos'>
            <h3>Cobranças Pagas</h3>
            <h2>{formatToLocaleCurrency(cobrancasPagasResumo.valor ?? 0)}</h2>
          </div>
        </div>

        <div className='cobrancavencida'>
          <div className='container-icones'>
            <img src={IconVencida} alt='icone' />
          </div>

          <div className='cobranca-infos'>
            <h3>Cobranças Vencidas</h3>
            <h2>{formatToLocaleCurrency(cobrancasVencidasResumo.valor ?? 0)}</h2>
          </div>
        </div>

        <div className='cobrancaprevista'>
          <div className='container-icones'>
            <img src={IconPrevista} alt='icone' />
          </div>

          <div className='cobranca-infos'>
            <h3>Cobranças Previstas</h3>
            <h2>{formatToLocaleCurrency(cobrancasPrevistasResumo.valor ?? 0)}</h2>
          </div>
        </div>
      </div>

      <div className='container-cobrancas' >
        <Card
          cor={0}
          dados={cobrancasVencidas}
          resumo={cobrancasVencidasResumo}
          titulo={'Cobranças Vencidas'}
        />

        <Card
          cor={1}
          dados={cobrancasPrevistas}
          resumo={cobrancasPrevistasResumo}
          titulo={'Cobranças Previstas'}
        />

        <Card
          cor={2}
          dados={cobrancasPagas}
          resumo={cobrancasPagasResumo}
          titulo={'Cobranças Pagas'}
        />
      </div>

      <div className='container-clientes' >
        <Card
          cliente={true}
          cor={0}
          dados={listaClientes.clientesInadimplente}
          titulo={'Clientes Inadimplentes'}
        />

        <Card
          cliente={true}
          cor={2}
          dados={listaClientes.clientesEmDia}
          titulo={'Clientes em dia'}
        />
      </div>
    </div >
  );
};

export default Home;
